var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M879 101L879 129",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 879.5,
    cy: 96.3333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M876.105 105C875.637 105 875.236 104.834 874.903 104.501C874.57 104.168 874.403 103.768 874.403 103.3C874.403 102.833 874.57 102.432 874.903 102.099C875.236 101.766 875.637 101.6 876.105 101.6C876.573 101.6 876.973 101.766 877.306 102.099C877.64 102.432 877.806 102.833 877.806 103.3C877.806 103.768 877.64 104.168 877.306 104.501C876.973 104.834 876.573 105 876.105 105ZM884.613 105C884.145 105 883.744 104.834 883.411 104.501C883.078 104.168 882.911 103.768 882.911 103.3C882.911 102.833 883.078 102.432 883.411 102.099C883.744 101.766 884.145 101.6 884.613 101.6C885.081 101.6 885.481 101.766 885.814 102.099C886.148 102.432 886.314 102.833 886.314 103.3C886.314 103.768 886.148 104.168 885.814 104.501C885.481 104.834 885.081 105 884.613 105ZM875.382 91.4L877.423 95.65H883.379L885.719 91.4H875.382ZM874.573 89.7H887.122C887.449 89.7 887.697 89.8452 887.867 90.1356C888.037 90.426 888.044 90.72 887.888 91.0175L884.868 96.4575C884.712 96.7408 884.503 96.9604 884.24 97.1162C883.978 97.2721 883.691 97.35 883.379 97.35H877.041L876.105 99.05H886.314V100.75H876.105C875.467 100.75 874.985 100.47 874.658 99.9106C874.332 99.351 874.318 98.795 874.616 98.2425L875.764 96.16L872.702 89.7H871V88H873.765L874.573 89.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.f20430e5aee84b2051b856c12f31c53f.svg";
export { ForwardRef as ReactComponent };